import {
  CardContainer,
  EntityCard,
  IFlowFeatures,
  IFlowIcon,
  IThingByTypeResponse,
  useEntityActions,
  useEnvironment,
} from '@diana/core';
import React, { useCallback, useMemo } from 'react';
import { routeUrls } from '../../app/Routing/RouteUrls';
import { useNavigate } from 'react-router-dom';
import { SxProps } from '@mui/system';

export const ThingCard = (props: {
  entity: IThingByTypeResponse;
  containerSx?: SxProps;
  imageUrl?: string;
  icon?: IFlowIcon | null;
  peoplePage?: boolean;
  showSidePeek?: boolean;
  flowFeatures?: IFlowFeatures | null;
}) => {
  const {
    entity,
    containerSx = {},
    icon,
    imageUrl,
    peoplePage,
    showSidePeek,
    flowFeatures,
  } = props;
  const environment = useEnvironment();
  const navigate = useNavigate();
  const route = useMemo(
    () =>
      peoplePage
        ? routeUrls.user.url({ environment, userId: entity.id }, null)
        : routeUrls.thing.url({ environment, thingId: entity.id }, null),
    [entity.id, environment, peoplePage],
  );

  const onEditClick = useCallback(() => {
    navigate(route);
  }, [navigate, route]);

  const { actions } = useEntityActions({
    onEditClick,
    entity,
    hideIcons: true,
  });

  return (
    <CardContainer sx={containerSx}>
      <EntityCard
        href={route}
        entity={entity}
        peoplePage={peoplePage}
        openInSidePeek={showSidePeek}
        actions={actions}
        icon={{ imageUrl, icon: icon?.shape ?? '', color: icon?.color ?? '' }}
        flowFeatures={flowFeatures}
      />
    </CardContainer>
  );
};
